export default __webpack_public_path__ + "static/media/mayaicon_light.467a30c3.svg";